import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';

import './StickerInsurance.css'
import Img from 'img/insurance-sticker.png'

export default (props) => (
  <Card className="card-sticker-insurance">
    <CardTitle title="" />
    <CardText>
      <img src={Img} width="540" height="400" alt="Versicherungs-Sticker" />
      <br />
      <br />
      <span>Sie haben den Versicherungs-Sticker gewählt.</span>
      <br />
      <span>Viel Vergnügen beim Ausprobieren!</span>
    </CardText>
  </Card>
);



// WEBPACK FOOTER //
// ./src/components/stickers/StickerInsurance.jsx